import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { AdminView } from "../VIEW/AdminView";
import { useAuth } from "../FIREBASE/useAuth";
import routeUrls from "../COMPONENTS/navbar/navLink";

function AdminPage() {
  const { user, loading, isAdmin } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (loading || isAdmin) return;
    // Signed out → login; signed in as anyone else → back to the blog (read-only).
    history.replace(user ? routeUrls.BLOGG : `${routeUrls.LOGIN}?from=${routeUrls.ADMIN}`);
  }, [user, isAdmin, loading]);

  if (loading || !isAdmin) return null;
  return <AdminView />;
}

export default AdminPage;
